import {memo} from 'react';
import type {ReactNode} from 'react';
import styles from './Card.module.scss';

interface CardProps {
    children: ReactNode;
    /** Navy fill on hover: copy turns white and the icon tile inverts (as on the KeyServices cards). */
    blueHover?: boolean;
}

/**
 * Plain stand-in for Ui-components/home/common-card: white rounded card with a white inner ring that lifts and gains a
 * deep-blue border on hover. Children keep the original's hover hooks (`.font-headers`, `.font-regular-text`,
 * `.common-icon-tile`, `.home-service-icon`, `.card-tinted-footer`) for the blue-hover variant.
 */
const Card = ({children, blueHover}: CardProps) => (
    <div className={blueHover ? `${styles.card} ${styles.blueHover}` : styles.card}>
        <div className={styles.inner}>{children}</div>
    </div>
);

export default memo(Card);
